import React from "react";
import Button from "@mui/material/Button";
import { AddToCartWrapper } from "./Addtocart.style";
import FlashOnOutlinedIcon from "@mui/icons-material/FlashOnOutlined";
import styled from "styled-components";

const BuyNowCTA = ({
  handleBuyNowCTA = () => {},
  isDeliverable = true,
  checkPinCodeAvailable,
}) => {




   const AddToCartButton = styled.div`
  
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height:  41px;
  font-size: 1rem;
  font-family :Ancizar Sans, sans-serif;
  font-weight: 500;
  background-color: rgb(253 124 4);
  color: white;
  cursor: pointer;
  border-radius: 5px;


  `
  return (
    <AddToCartWrapper>
      <AddToCartButton
        onClick={handleBuyNowCTA}
        enabled={isDeliverable && checkPinCodeAvailable}
        style={{ backgroundColor: isDeliverable && checkPinCodeAvailable ? "rgb(253 124 4)" : "rgb(232, 232, 232)",color: isDeliverable && checkPinCodeAvailable ? "white" : "rgba(75, 75, 75, 0.5)" }}
      >
        <FlashOnOutlinedIcon />
        Buy Now
      </AddToCartButton>
    </AddToCartWrapper>
  );
};

export default BuyNowCTA;
